import React from "react";
import '../../assets/styles/css/antd.css';
import { Redirect, Route, useRouteMatch } from "react-router-dom";
import WebHeader from "./master/WebHeader";
import { Layout } from 'antd';
import Colors from "@dwellpass-client/common/utils/constants/Colors";
import Endpoints from "@dwellpass-client/common/utils/constants/Endpoints";
import Dashboard from "./Dashboard";
import NavSider from "./master/NavSider";
import UserProfile from "../shared/UserProfile";
import Resources from "./Resources";
import Engagement from "./Engagement";
import Payments from "./Payments";
import PaymentMethods from "./PaymentMethods";
import Directory from "./Directory";
import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";

const { Content, Footer } = Layout;

export const Master = (props) => {
    const getYear = () => {
        return new Date().getFullYear();
    }

    let match = useRouteMatch();

    const stripePromise = loadStripe(process.env.STRIPE_PUBLISHABLE_KEY);

    return (
        <Layout style={{ height: "100vh" }}>
            <NavSider />
            <Layout>
                <WebHeader navigation={props.navigation} />
                <Content style={styles.contentWrapper}>
                    <Redirect exact from="/resident" to={match.url+"/dashboard"} />
                    <div style={styles.contentContainer}>
                        <Route path={match.path+"/dashboard"} component={Dashboard} />
                        <Route exact path={match.path+"/posts"} component={Engagement} />
                        <Route exact path={match.path+"/resources"} component={Resources} />
                        <Route exact path={match.path+"/directory"} component={Directory} />
                        <Route exact path={match.path+"/user-profile"} component={UserProfile} />
                        <Elements stripe={stripePromise}>
                            <Route exact path={match.path+"/payments"} component={Payments} />
                            <Route exact path={match.path+"/payment-methods"} component={PaymentMethods} />
                        </Elements>
                    </div>
                </Content>
                <Footer style={{ textAlign: 'center' }}>Copyright © {getYear()} dwellPass. All rights reserved. <a href={Endpoints.termsOfUseURL} target="_blank">Terms of Use</a> | <a href={Endpoints.privacyPolicyURL} target="_blank">Privacy Policy</a></Footer>
            </Layout>
        </Layout>
    );
};

const styles = {
    contentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        padding: 24,
        margin: 0,
    },
    contentContainer: {
        flex: 1,
        padding: 18,
        backgroundColor: Colors.monoBright,
        overflow: "scroll"
    }
}

export default Master;